<template>
  <div class="mb-4">
    <v-row class="px-2" no-gutters>
      <v-col
        align-self="center"
        cols="auto"
        @click="$router.push(`/garden/${plant.userId}`)"
      >
        <v-img
          class="shrink rounded-circle ma-3"
          :src="plant.userProfilePictureUrl"
          transition="fade-transition"
          height="40"
          width="40"
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-icon size="24" color="primary">mdi-account-outline</v-icon>
            </v-row>
          </template>
        </v-img></v-col
      >
      <v-col
        align-self="center"
        cols="auto"
        @click="$router.push(`/garden/${plant.userId}`)"
      >
        <v-row
          no-gutters
          class="font-weight-bold text-subtitle-2 secondary--text"
          >{{ plant.userNickname }}
          <span class="mx-1 font-weight-regular"> gives a plant</span>
        </v-row>
        <v-row no-gutters class="text-caption grey--text">{{
          handleISOToRelativeTime(plant.createdAt.toDate())
        }}</v-row>
      </v-col>
      <v-col></v-col>
      <v-col cols="auto" align-self="center">
        <div
          v-if="plant.loversId"
          class="mr-4"
          @click="
            $emit(
              'toggleLove',
              {
                itemId: plant.id,
                parentId: plant.userId,
                target: 'plants',
                self,
                deep: true,
              },
              plant
            )
          "
        >
          <span class="secondary--text text-h6 mr-1">{{
            plant.loversId.length
          }}</span>
          <v-icon
            class="mb-2"
            :color="plant.loversId.includes(self.id) ? 'primary' : 'secondary'"
            >{{
              plant.loversId.includes(self.id)
                ? "mdi-thumb-up"
                : "mdi-thumb-up-outline"
            }}</v-icon
          >
        </div>
      </v-col>
    </v-row>
    <!-- <v-row
      no-gutters
      class="px-5 mt-n1 mb-2 secondary--text font-weight-medium"
      @click="goToPlant"
    >
      {{ plant.status === "to-give" ? "Plant to give" : "Plant given" }}
    </v-row> -->

    <v-row
      @click="goToPlant"
      no-gutters
      v-if="plant.descriptionSharing"
      align-self="center"
      class="secondary--text px-5 mb-2 mt-n1"
      style="white-space: pre-line"
    >
      {{ plant.descriptionSharing }}
    </v-row>
    <v-row no-gutters style="position: relative" class="px-3">
      <v-img
        @click="goToPlant"
        class="shrink rounded-xl"
        :src="plant.pictureUrl"
        transition="fade-transition"
        width="100%"
        height="200"
        ><template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-row>
        </template>
        <v-chip
          color="primary"
          class="ma-4"
          v-if="plant.status === 'given'"
          style="position: absolute; z-index: 2; right: 0; bottom: 0"
          >Plant Given</v-chip
        >
        <div
          v-if="plant.numberOfComments"
          style="
            position: absolute;
            z-index: 2;
            left: 18px;
            bottom: 9px;
            text-shadow: 0px 0px 2px rgba(150, 150, 150, 1);
          "
          class="white--text text-h6"
        >
          <div class="d-inline-block">
            {{ plant.numberOfComments }}
          </div>
          <v-icon
            class="mr-0 ml-2 mt-n1"
            color="white"
            style="text-shadow: 0px 0px 2px rgba(150, 150, 150, 1)"
            >mdi-chat-outline</v-icon
          >
        </div></v-img
      >
    </v-row>
    <!-- <v-row no-gutters class="mt-3" v-if="plant.commentText">
      <v-col cols="auto"
        ><v-row no-gutters
          ><v-col
            ><v-img
              :src="plant.commentProfilePictureUrl"
              class="primary rounded-circle shrink"
              width="34"
              height="34"
              transition="fade-transition"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-icon size="20" color="white">mdi-account</v-icon>
                </v-row>
              </template>
            </v-img></v-col
          ></v-row
        ></v-col
      ><v-col class="pl-2" style="width: calc(100% - 50px)"
        ><v-row no-gutters class="text-body-2 font-weight-bold my-0 py-0">
          <v-col cols="auto">{{
            plant.commentUserNickname
              ? plant.commentUserNickname
              : "Anonymous user"
          }}</v-col
          ><v-col cols="auto" class="pl-2 text-caption grey--text">{{
            handleISOToRelativeTime(plant.updatedAt.toDate())
          }}</v-col>
        </v-row>
        <v-row no-gutters>{{ plant.commentText }}</v-row>
      </v-col>
    </v-row> -->
  </div>
</template>

<script>
import { ISOToRelativeTime } from "@/utils/dates.js";

export default {
  name: "PlantSharing",
  props: ["plant", "self"],
  methods: {
    handleISOToRelativeTime(date) {
      return ISOToRelativeTime(date);
    },
    goToPlant() {
      this.$router.push(`/garden/${this.plant.userId}/plant/${this.plant.id}`);
    },
  },
};
</script>

<style >
</style>